export enum ValidPages {
  APPLICATION = 'APPLICATION',
  BACKOFFICE = 'BACKOFFICE',
  BATTERY_CARE = 'BATTERY_CARE'
}
